import ListDemandPage from './ListDemandPage.jsx';
import DetailDemandPage from './DetailDemandPage.jsx';

export {
  ListDemandPage,
  DetailDemandPage
}


// WEBPACK FOOTER //
// ./pages/demand/index.js